(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.customer-reviews-wrapper').forEach((wrapper) => {
    const whatsappSwiperEl = wrapper.querySelector('.whatsapp-swiper');
    const videoSwiperEl = wrapper.querySelector('.video-swiper');

    // Init Swipers
    const whatsappSwiper = new Swiper(whatsappSwiperEl, {
      slidesPerView: 2.5,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: wrapper.querySelector('.whatsapp-next'),
        prevEl: wrapper.querySelector('.whatsapp-prev')
      },
      pagination: {
        el: wrapper.querySelector('.whatsapp-pagination'),
        type: 'fraction'
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
        },
        0: {
          slidesPerView: 1.5,
          spaceBetween: 10
        }
      }
    });

    const videoSwiper = new Swiper(videoSwiperEl, {
      slidesPerView: 2.5,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: wrapper.querySelector('.video-next'),
        prevEl: wrapper.querySelector('.video-prev')
      },
      pagination: {
        el: wrapper.querySelector('.video-pagination'),
        type: 'fraction'
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5
        },
        0: {
          slidesPerView: 1.5,
          spaceBetween: 10
        }
      }
    });

    // Tab toggle scoped to this wrapper
    wrapper.querySelectorAll('.tab-btn').forEach((btn) => {
      btn.addEventListener('click', function () {
        wrapper.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        const target = this.dataset.target;

        if (target === "whatsapp") {
          whatsappSwiperEl.classList.remove('hidden');
          videoSwiperEl.classList.add('hidden');
        } else {
          videoSwiperEl.classList.remove('hidden');
          whatsappSwiperEl.classList.add('hidden');
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jewel-journey"] && !Shopify.designMode) return;
  try {
    
  function setEqualHeights() {
    if (window.innerWidth > 768) {
    const hotspots = document.querySelector('.only-image');
    const contents = document.querySelector('.jewel-journey');
  
    let maxHeight = Math.max(hotspots.clientHeight, contents.clientHeight);
    
    hotspots.style.height = maxHeight + 'px';
    contents.style.height = maxHeight + 'px';
    }else {
      // Reset heights for larger screens
      document.querySelector('.only-image').style.height = '';
      document.querySelector('.jewel-journey').style.height = '';
    }
  }
  
  // Run on page load & resize
  window.addEventListener('load', setEqualHeights);
  window.addEventListener('resize', setEqualHeights);
  document.addEventListener("DOMContentLoaded", function () {
    const journeySwiper = new Swiper('.journey-swiper', {
      slidesPerView: 2,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.journey-next',
        prevEl: '.journey-prev'
      },
      pagination: {
        el: '.journey-pagination',
        type: 'fraction'
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        0: {
          slidesPerView: 1.3,
          spaceBetween: 10
        }
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Modal logic
  function openModal(id) {
    var modal = document.getElementById('tc-modal-' + id);
    if (!modal) return;
    modal.hidden = false;
    modal.querySelector('.tc-modal__close') && modal.querySelector('.tc-modal__close').focus();
    document.body.style.overflow = 'hidden';
    var trigger = document.querySelector('[data-tc-modal-trigger="' + id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    var id = modal.id.replace('tc-modal-', '');
    var trigger = document.querySelector('[data-tc-modal-trigger="' + id + '"]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  }

  document.addEventListener('click', function (e) {
    // Open modal
    var trigger = e.target.closest('[data-tc-modal-trigger]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.dataset.tcModalTrigger);
      return;
    }
    // Close modal
    var closeEl = e.target.closest('[data-tc-modal-close]');
    if (closeEl) {
      closeModal(closeEl.closest('.tc-modal'));
      return;
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openModal = document.querySelector('.tc-modal:not([hidden])');
      if (openModal) closeModal(openModal);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
